<template>
    <div class="grid" v-if="getMovil() == null || getParada() == null">
		<div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
			<Message severity="error" class="p-col-12">
				Para poder operar en el sistema debe seleccionar el comedor y parada donde está cumpliendo funciones.
			</Message>
		</div>
	</div>
	<div class="grid" v-if="getMovil() != null && getParada() != null">
		<div class="col-12 md:col-6 xl:col-3">
			<div class="card grid-nogutter widget-overview-box widget-overview-box-1">
				<span class="overview-icon">
					<i class="pi pi-exclamation-circle"></i>
				</span>
				<span class="overview-title">Entrada / salida de stock</span>
				<div class="grid overview-detail">
					<div class="col-12">
						<div class="overview-subtext">En caso de ingreso o devolución de stock registre si es entrada o salida, la cantidad de viandas involucradas, suba la imagen del remito y una observación complementaria a la entrega / devolución.</div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid p-mt-5">
			<div class="col-12">
				<div class="card">
                    <Toast/>
                    <Message class="p-col-12">
                        Usted está operando en:<br>
                        <i class="pi pi-map"/> {{getMovilName()}}<br>
                        <i class="pi pi-map-marker"/> <i>{{getParadaName()}}</i>
                    </Message>
                    <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
                        <div class="p-field p-col-12 p-md-6">
                            <label for="motivos">Motivo de remito</label>
                            <SelectButton v-model="motivo" :options="selectButtonValues" optionLabel="name" optionValue="value" :class="{'p-invalid': submittedMotivo && motivo == null}"/>
                            <small class="p-invalid" v-if="submittedMotivo && motivo == null">Se requiere seleccionar un motivo de remito.</small>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <label for="motivos">Cantidad de viandas involucradas</label>
                            <InputNumber v-model="cantidad" mode="decimal" :min="1" showButtons inputId="horizontal-buttons" buttonLayout="horizontal" :step="1" readonly="true"/>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <label for="obs">Observación</label>
                            <Textarea id="obs" v-model="observacion" :class="{'p-invalid': (submittedObs && !observacion) || (submittedObs && observacion.length > 128)}" :autoResize="true" v-on:keydown.enter.prevent/>
                            <small class="p-invalid" v-if="submittedObs && !observacion">Se requiere una aclaración en relación a la entrada / salida de stock.</small>
                            <small class="p-invalid" v-if="submittedObs && observacion && observacion.length > 128">El largo del texto no puede superar los 128 caracteres.</small>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <label for="motivos">Adjuntar imagen del remito</label>
                            <FileUpload name="remito[]" url="./" @upload="onUpload" @uploader="customBase64Uploader" :multiple="false" accept="image/*" :maxFileSize="5000000" customUpload="true"
                            uploadLabel="Adjuntar" chooseLabel="Seleccionar" cancelLabel="Cancelar" fileLimit="1"
                            invalidFileTypeMessage="Tipo de archivo incorrecto. Debe subir una imagen."
                            invalidFileLimitMessage="Debe subir una única imagen."
                            invalidFileSizeMessage="El archivo es demasiado grande. Limite 5 MB."
                            ref="fileUpload"
                            />
                        </div>
                    </div>
                    <Toolbar>
                        <template v-slot:left>
                            <Button label="Limpiar" @click="clearAll()" icon="pi pi-eraser" iconPos="left" class="p-button-secondary mr-2 mb-2"/>
                        </template>

                        <template v-slot:right>
                            <Button label="Entregar" @click="entregar()" icon="pi pi-angle-right" iconPos="left" :loading="loading"/>
                        </template>
                    </Toolbar>
				</div> 
			</div>
		</div>
	</div>	

	<Dialog header="Aguarde..." v-model:visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
		<div align="center">
			<ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
		</div>
	</Dialog>
	
</template>

<script>
import SmartService from '../service/SmartService';
export default {
	data() {
		return {
			wait: false,
            loading: false,
            motivo: null,
            cantidad: 1,
            observacion: null,
            submittedMotivo: false,
            submittedObs: false,
            submittedRemito: false,
            loadingmotivo: false,
            remitobase64: null,
            selectButtonValues: [
					{name: 'Entrada', value: 0},
					{name: 'Salida', value: 1},
			],
		}
	},	
	smartService: null,
	created() {
		this.smartService = new SmartService();
	},
	mounted() {
        
	},
	methods: {
        getMovil(){
            return localStorage.movil_id;
        },

        getParada(){
            return localStorage.parada_id;
        },

        getMovilName(){
            return localStorage.movil_name;
        },

        getParadaName(){
            return localStorage.parada_name;
        },

        getIdTec(){
            return localStorage.tec_id;
        },

        clearAll(){
            this.submittedMotivo = false;
            this.submittedObs = false;
            this.submittedRemito = false;
            this.motivo=null;
            this.cantidad = 1;
            this.observacion = null;
            this.remitobase64 = null;
            //Esto para limpiar el fileupload
            this.$refs.fileUpload.clear();
            this.$refs.fileUpload.uploadedFileCount = 0;
        },

        entregar(){
            this.registrarRemito();
        },

        async customBase64Uploader(event){
            const file = event.files[0];
            const reader = new FileReader();
            let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url
            reader.readAsDataURL(blob);
            const get64String = () => {
                return new Promise(resolve => {
                    reader.onloadend = function () {
                        resolve(reader.result);
                    };
                }) 
            }
            const aux = await get64String();
            this.remitobase64 = aux;
            this.$toast.add({severity: 'info', summary: 'Se adjunto imagen', detail: 'Imagen lista para ser enviada', life: 3000});
        },

        onUpload(){
            /* console.log("Entre aca"); */
            this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
		},

        async registrarRemito() {
			this.submittedMotivo = true;
            this.submittedObs = true;
            this.submittedRemito = true;
            //Imprimir datos
            /* console.log("Tipo: " + this.motivo);
            console.log("Viandas: " + this.cantidad);
            console.log("Movil: " + this.getMovil());
            console.log("Obs: " + this.observacion);
            console.log("Tecnico: " + this.getIdTec());
            console.log("Imagen: " + this.remitobase64); */
            if (this.remitobase64 == null)
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Debe adjuntar la imagen del remito', life: 3000});
            else{
                if ((this.motivo != null) && this.cantidad && (this.observacion && this.observacion.length <= 128) && (this.remitobase64 != null)) {
                    this.wait= true;
                    this.loading = true;
                    this.smartService.registrarRemito(this.motivo,this.cantidad,this.remitobase64,Number(this.getMovil()),this.observacion,Number(this.getIdTec())).then(data => {
                        let msg = data;
                        this.wait= false;
                        this.loading = false;
                        if (msg != null){
                            if (msg.includes("ERROR")){
                                msg = msg.replace("ERROR","");
                                this.$toast.add({severity:'error', summary: 'Error', detail: msg, life: 3000});
                            }
                            else if (msg.includes("WARN")){
                                msg = msg.replace("WARN","");
                                this.$toast.add({severity:'warn', summary: 'Atención', detail: msg, life: 3000});
                            }
                            else{
                                this.$toast.add({severity:'success', summary: 'Registro exitoso', detail:msg, life: 3000});    
                            }
                        }
                        else{
                            this.$toast.add({severity:'error', summary: 'El remito no fue registrado', detail: 'Ha ocurrido un error al comunicarse con el servidor. Cierre sesión, vuelva a ingresar e intentelo nuevamente.', life: 5000});
                        }
                        //Limpio el form
                        this.clearAll();
                    });
                }
            }
        }
		
	},
}
</script>

<style scoped lang="scss">
	.overview-detail {
        text-align: left;
        margin-top: 2rem;

        .p-col-6 {
            padding: .5rem;
        }
    }
</style>